import InfoTabContainer from './InfoTabContainer';

export default InfoTabContainer;
